(() => {
  const countdownIntervals = new WeakMap();

  function padNumber(value) {
    return String(Math.max(0, value)).padStart(2, '0');
  }

  function stopCountdown(element) {
    const existingInterval = countdownIntervals.get(element);

    if (existingInterval) {
      window.clearInterval(existingInterval);
      countdownIntervals.delete(element);
    }
  }

  function initializeCountdown(element) {
    if (!element || element.dataset.jaCountdownInitialized === 'true') {
      return;
    }

    const dateString = element.dataset.countdownDate;
    const endDate = new Date(dateString);

    const daysElement = element.querySelector('[data-ja-days]');
    const hoursElement = element.querySelector('[data-ja-hours]');
    const minutesElement = element.querySelector('[data-ja-minutes]');
    const secondsElement = element.querySelector('[data-ja-seconds]');
    const timerElement = element.querySelector('.ja-home-hero__countdown');
    const completeElement = element.querySelector(
      '[data-ja-countdown-complete]'
    );

    if (
      Number.isNaN(endDate.getTime()) ||
      !daysElement ||
      !hoursElement ||
      !minutesElement ||
      !secondsElement
    ) {
      console.warn(
        'JA countdown: Invalid countdown date. Use ISO format, such as 2026-12-31T23:59:59-06:00.'
      );

      return;
    }

    element.dataset.jaCountdownInitialized = 'true';

    function updateCountdown() {
      const now = new Date().getTime();
      const distance = endDate.getTime() - now;

      if (distance <= 0) {
        daysElement.textContent = '00';
        hoursElement.textContent = '00';
        minutesElement.textContent = '00';
        secondsElement.textContent = '00';

        if (timerElement) {
          timerElement.hidden = true;
        }

        if (completeElement) {
          completeElement.hidden = false;
        }

        stopCountdown(element);
        return;
      }

      const days = Math.floor(distance / 86400000);
      const hours = Math.floor((distance % 86400000) / 3600000);
      const minutes = Math.floor((distance % 3600000) / 60000);
      const seconds = Math.floor((distance % 60000) / 1000);

      daysElement.textContent = padNumber(days);
      hoursElement.textContent = padNumber(hours);
      minutesElement.textContent = padNumber(minutes);
      secondsElement.textContent = padNumber(seconds);
    }

    updateCountdown();

    const interval = window.setInterval(updateCountdown, 1000);
    countdownIntervals.set(element, interval);
  }

  function initializeAllCountdowns(container = document) {
    container
      .querySelectorAll('[data-ja-countdown]')
      .forEach(initializeCountdown);
  }

  function resetSectionCountdown(section) {
    section.querySelectorAll('[data-ja-countdown]').forEach((element) => {
      stopCountdown(element);
      delete element.dataset.jaCountdownInitialized;
      initializeCountdown(element);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeAllCountdowns();
    });
  } else {
    initializeAllCountdowns();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeAllCountdowns(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target
      .querySelectorAll('[data-ja-countdown]')
      .forEach(stopCountdown);
  });

  document.addEventListener('shopify:section:select', (event) => {
    resetSectionCountdown(event.target);
  });
})();